import { render } from "./OffCanvas.vue?vue&type=template&id=5276dce1"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import "./OffCanvas.vue?vue&type=style&index=0&id=5276dce1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__